export const withdrawalText = {
	de: {
		eyebrow: 'Für Ihre Bestellung',
		detailsTitle: 'Ihre Angaben',
		reviewTitle: 'Prüfen und bestätigen',
		stepsLabel: 'Fortschritt Ihres Widerrufs',
		detailsStep: 'Angaben eingeben',
		reviewStep: 'Widerruf bestätigen',
		required: 'Alle Felder sind erforderlich.',
		nameHint: 'Bitte geben Sie den Namen an, unter dem Sie bestellt haben.',
		referenceHint:
			'Die Bestellnummer finden Sie in Ihrer Bestellbestätigung. Alternativ können Sie eine eindeutige Vertragsreferenz angeben.',
		emailHint: 'An diese Adresse senden wir die Eingangsbestätigung.',
		reviewHint:
			'Prüfen Sie Ihre Angaben. Mit „Widerruf bestätigen“ übermitteln Sie die folgende Erklärung.',
		detailsHint:
			'Im nächsten Schritt können Sie alles prüfen, bevor Sie Ihren Widerruf bestätigen.',
		statementTitle: 'Ihre Widerrufserklärung',
		helpTitle: 'Gut zu wissen',
		guestHint: 'Sie benötigen kein Kundenkonto und müssen sich nicht anmelden.',
		receiptHint: 'Nach dem Absenden erhalten Sie eine Bestätigung per E-Mail.',
		policyHint:
			'Informationen zu Fristen, Rücksendung und Kontakt finden Sie in unserer Widerrufsbelehrung.',
		policy: 'Widerrufsbelehrung lesen',
		privacy: 'Datenschutzerklärung',
		submitting: 'Wird übermittelt …',
		reviewing: 'Angaben werden geprüft …',
		saved: 'Bitte bewahren Sie diese Referenz als Nachweis auf.',
		home: 'Zurück zum Shop',
		invalidName:
			'Bitte geben Sie Ihren vollständigen Namen ein (maximal 200 Zeichen).',
		invalidReference:
			'Bitte geben Sie eine Bestellnummer oder Vertragsreferenz ein (maximal 200 Zeichen).',
		invalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
		start: 'Vertrag widerrufen',
		title: 'Widerruf erklären',
		intro:
			'Sie möchten Ihren Vertrag widerrufen? Geben Sie Ihre Bestelldaten ein und bestätigen Sie anschließend Ihre Erklärung. Eine Anmeldung ist nicht erforderlich.',
		name: 'Vollständiger Name',
		reference: 'Bestellnummer oder Vertragsreferenz',
		email: 'E-Mail-Adresse für die Bestätigung',
		review: 'Widerruf prüfen',
		confirm: 'Widerruf bestätigen',
		edit: 'Angaben bearbeiten',
		statement:
			'Hiermit widerrufe ich den in dieser Erklärung bezeichneten Vertrag.',
		error: 'Bitte prüfen Sie Ihre Angaben und versuchen Sie es erneut.',
		unavailable:
			'Die Übermittlung konnte nicht bestätigt werden. Bitte versuchen Sie es erneut. Ihre Angaben bleiben erhalten.',
		limited:
			'Zu viele Anfragen. Bitte versuchen Sie es später erneut oder nutzen Sie die Kontaktdaten in der Widerrufsbelehrung.',
		success: 'Ihr Widerruf ist eingegangen.',
		receipt: 'Die Eingangsbestätigung wird an Ihre E-Mail-Adresse gesendet.',
		pending:
			'Der E-Mail-Versand steht noch aus. Ihr Widerruf wurde gespeichert.',
		submitted: 'Eingegangen am',
		id: 'Referenz',
	},
	en: {
		eyebrow: 'For your order',
		detailsTitle: 'Your details',
		reviewTitle: 'Review and confirm',
		stepsLabel: 'Withdrawal progress',
		detailsStep: 'Enter your details',
		reviewStep: 'Confirm withdrawal',
		required: 'All fields are required.',
		nameHint: 'Enter the name used for your order.',
		referenceHint:
			'Find your order number in your order confirmation. You can also enter another unambiguous contract reference.',
		emailHint: 'We will send your receipt to this address.',
		reviewHint:
			'Check your details. Selecting “Confirm withdrawal” submits the declaration below.',
		detailsHint:
			'You can review everything in the next step before confirming your withdrawal.',
		statementTitle: 'Your withdrawal declaration',
		helpTitle: 'Good to know',
		guestHint: 'No account or sign-in is needed.',
		receiptHint: 'After submitting, you will receive a confirmation by email.',
		policyHint:
			'Find information about deadlines, returns and contact details in our withdrawal policy.',
		policy: 'Read the withdrawal policy',
		privacy: 'Privacy policy',
		submitting: 'Submitting …',
		reviewing: 'Checking details …',
		saved: 'Keep this reference as a record of your declaration.',
		home: 'Back to the shop',
		invalidName: 'Enter your full name (up to 200 characters).',
		invalidReference:
			'Enter an order number or contract reference (up to 200 characters).',
		invalidEmail: 'Enter a valid email address.',
		start: 'Withdraw from contract',
		title: 'Declare withdrawal',
		intro:
			'Want to withdraw from your contract? Enter your order details, then review and confirm your declaration. No sign-in is needed.',
		name: 'Full name',
		reference: 'Order number or contract reference',
		email: 'Email address for the receipt',
		review: 'Review withdrawal',
		confirm: 'Confirm withdrawal',
		edit: 'Edit details',
		statement:
			'I hereby withdraw from the contract identified in this declaration.',
		error: 'Please check your details and try again.',
		unavailable:
			'We could not confirm submission. Please try again. Your details have been retained.',
		limited:
			'Too many requests. Please try again later or use the contact details in the withdrawal policy.',
		success: 'Your withdrawal has been received.',
		receipt: 'The receipt will be sent to your email address.',
		pending: 'Email delivery is pending. Your withdrawal has been saved.',
		submitted: 'Received at',
		id: 'Reference',
	},
}
export type WithdrawalLocale = keyof typeof withdrawalText
export function withdrawalLocale(locale?: string): WithdrawalLocale {
	return locale?.startsWith('de') ? 'de' : 'en'
}
